<!-- CollapsibleAccordion.vue -->
<!-- A generic collapsible accordion with a title and default slot for content -->
<template>
    <div class="ppv2-border ppv2-border-black ppv2-border-opacity-[8%] ppv2-rounded-xl ppv2-overflow-visible">
        <button
            type="button"
            class="ppv2-bg-black ppv2-bg-opacity-[3%] hover:ppv2-bg-opacity-[6%] ppv2-w-full ppv2-px-4 ppv2-py-3 ppv2-flex ppv2-items-center ppv2-justify-between ppv2-text-sm poppinsMedium ppv2-text-black ppv2-rounded-xl ppv2-transition-all ppv2-duration-200"
            :class="{ 'ppv2-rounded-b-none': isOpen }"
            @click="isOpen = !isOpen"
        >
            <span>{{ title }}</span>
            <ChevronDown
                :size="16"
                class="ppv2-text-[#A0A4AE] ppv2-transition-transform ppv2-duration-300"
                :class="{ 'ppv2-rotate-180 ppv2-text-purple': isOpen }"
            />
        </button>

        <div v-show="isOpen" class="ppv2-p-4 ppv2-border-t ppv2-border-black ppv2-border-opacity-[8%] ppv2-space-y-4">
            <slot />
        </div>
    </div>
</template>

<script>
import { ChevronDown } from 'lucide-vue'

export default {
    name: 'CollapsibleAccordion',

    components: { ChevronDown },

    props: {
        title: {
            type: String,
            required: true,
        },
        // Allow external control of open state
        value: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['input'],

    data() {
        return {
            isOpen: this.value,
        }
    },

    watch: {
        value(val) {
            this.isOpen = val
        },
        isOpen(val) {
            this.$emit('input', val)
        },
    },
}
</script>
